import React from 'react';
import { Quarters } from 'components/quarters/Quarters';

export const QuartersSlice = ({ tagline, title, items }) => {
  return (
    <Quarters tagline={tagline} title={title}>
      {items.map((year, i) => (
        <Quarters.Year key={year.title} title={year.title} open={i < 4}>
          {year.quarters.map((quarter) => (
            <Quarters.Quarter
              key={`${year.title}${quarter.quarter}`}
              title={quarter.quarter}
              consolidated={quarter.consolidated}
              press={quarter.press}
              earnings={quarter.earnings}
              webcast={quarter.webcast}
            />
          ))}
        </Quarters.Year>
      ))}
    </Quarters>
  );
};

export default QuartersSlice;
